import { styled } from "styled-components";

export const Button = styled.button`
  font-size: 18px;
  width: 150px;
  border-radius: 50px;
  height: 70px;
  background: #383838;
  color: rgb(250, 250, 251);
  cursor: pointer;
`;
